import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Disc3 } from "lucide-react";

const MECHANICS = [
  {
    id: "wheel",
    name: "Wheel Spinner",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/e18cd9a35881c05ecc6eea89ee7f3c56e23ab9b0c75f421ceea7419b1e3e950d.jpeg",
    description: "Build a wheel of wedges — auto-resolved (points, damage) or GM-narrated. Everyone watches it spin live and land together.",
  },
  {
    id: "trivia",
    name: "Trivia Board",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/cd2746885819ae3b08ff8675821a8cd78eae081fe7feabf8a9a39b73466e01ee.jpeg",
    description: "Stack up questions by category and points, reveal them Jeopardy-style, and award the contestant who answers correctly.",
  },
  {
    id: "items",
    name: "Item Collection",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/e764f2b1c15a5383e768f959b87bdc93e59ae0c7671112acf870cae91e06dc82.jpeg",
    description: "Race for named prizes — link one to a real Item Card and collecting it grants the actual item into the winner's inventory.",
  },
];

export function GameShowIntroModal({ open, onOpenChange, onHost }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#151613] border-white/10 text-[#f1e0c5] max-w-3xl p-0 overflow-hidden" data-testid="gameshow-intro-modal">
        <DialogHeader className="p-6 md:p-8 pb-2 bg-gradient-to-b from-[#1c2a1c] to-[#151613]">
          <DialogTitle className="font-display text-3xl md:text-4xl text-center text-[#3F9142] flex items-center justify-center gap-2">
            <Disc3 className="w-7 h-7" /> Welcome to the Game Show
          </DialogTitle>
          <DialogDescription className="text-center text-[#f1e0c5]/50">Three mechanics you can mix and match, on any table or across a whole Raid.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-6 md:p-8 pt-4">
          {MECHANICS.map((m) => (
            <div key={m.id} data-testid={`gameshow-intro-card-${m.id}`} className="flex flex-col rounded-xl overflow-hidden bg-black/30 border border-white/10 transition-all duration-300 hover:-translate-y-1 hover:border-[#3F9142]/60 hover:shadow-[0_0_30px_rgba(63,145,66,0.15)]">
              <div className="h-28 md:h-32 overflow-hidden relative">
                <img src={m.image} alt={m.name} className="object-cover w-full h-full" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#151613] via-transparent to-transparent" />
              </div>
              <div className="p-4 flex flex-col gap-1.5 flex-1">
                <h3 className="font-display text-lg text-[#3F9142]">{m.name}</h3>
                <p className="text-xs text-[#f1e0c5]/60 leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="px-6 md:px-8 pb-6 md:pb-8">
          <Button data-testid="gameshow-intro-host-button" onClick={onHost} className="w-full rounded-full bg-[#3F9142] hover:bg-[#357a39] uppercase tracking-wider text-sm">
            Host a Game Show
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
